import * as React from 'react';
import { useSelector } from 'react-redux';
import { GridLegacy, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import PostAddIcon from '@mui/icons-material/PostAdd';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EditIcon from '@mui/icons-material/Edit';
import StorageIcon from '@mui/icons-material/Storage';
import BackupIcon from '@mui/icons-material/Backup';
import RestoreIcon from '@mui/icons-material/Restore';
import InfoIcon from '@mui/icons-material/Info';
import RateReviewIcon from '@mui/icons-material/RateReview';
import { AppGlobalContext } from '../../../App';
import TEXT from './text';

const StyledPaper = styled(Paper)(({ theme }) => ({
    width: "auto",
    padding: theme.spacing(2),
    ...theme.typography.body2,
    textAlign: 'center',
    backgroundColor: theme.palette.secondary.main,
}));

export default function DbManagement_page_body() {
    const language = useSelector((state) => state.App_Settings.language);
    const AppGlobalContxt = React.useContext(AppGlobalContext);
    
    return (
        <GridLegacy component={"main"} container sx={{ marginLeft:"0px", marginRight:"20px", width: "auto" }} top={15} spacing={2}>
            <GridLegacy item xs={12}>
                <br />
                <br />
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("CreateDbGroup")}}>
                    <PostAddIcon fontSize="large" />
                    <br />
                    {TEXT.CreateDbGroup?.[language] || 'Create DB Group'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("CreateDb")}}>
                    <PostAddIcon fontSize="large" />
                    <br />
                    {TEXT.CreateDB?.[language] || 'Create Database'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("DbBrowser")}}>
                    <ManageSearchIcon fontSize="large" />
                    <br />
                    {TEXT.DbBrowser?.[language] || 'Browse Databases'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("EditDbGroup")}}>
                    <EditIcon fontSize="large" />
                    <br />
                    {TEXT.EditDbGroup?.[language] || 'Edit DB Group'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {alert('Export functionality - Coming soon!')}}>
                    <BackupIcon fontSize="large" />
                    <br />
                    {TEXT.ExportData?.[language] || 'Export Data'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {alert('Import functionality - Coming soon!')}}>
                    <RestoreIcon fontSize="large" />
                    <br />
                    {TEXT.ImportData?.[language] || 'Import Data'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {
                    const request = indexedDB.open('ShepherdDB');
                    request.onsuccess = (event) => {
                        const db = event.target.result;
                        const info = {
                            name: db.name,
                            version: db.version,
                            objectStores: Array.from(db.objectStoreNames)
                        };
                        db.close();
                        alert(`Database: ${info.name}\nVersion: ${info.version}\nObject Stores: ${info.objectStores.join(', ')}`);
                    };
                }}>
                    <InfoIcon fontSize="large" />
                    <br />
                    {TEXT.DatabaseInfo?.[language] || 'Database Info'}
                </StyledPaper>
            </GridLegacy>
            <GridLegacy item xs={6}>
                <StyledPaper elevation={3} onClick={() => {AppGlobalContxt.Body.setPageName("ChangeRequests")}}>
                    <RateReviewIcon fontSize="large" />
                    <br />
                    {TEXT.ChangeRequests?.[language] || 'Change Requests'}
                </StyledPaper>
            </GridLegacy>
        </GridLegacy>
    );
}